import api from 'api/axiosInstance';
import type { Connector } from 'types/transactions.types';

const getConnectors = (): Promise<Connector[]> =>
  api.get<Connector[]>('/v1/connectors').then(({ data }) => data);

export default getConnectors;
